import template from './local_settings_modal.html'

export default {
  template,
  controller: 'localSettingsModalController as localSettingsModal',
  bindings: {
    data: '<'
  }
}
